import react from 'react';
import { Grid } from '@mui/material';
import { usePhoneMode } from '../hooks';

export default function Footer() {
    const { isMobile, phoneMode } = usePhoneMode();
    return (
        <footer style={{ position: 'fixed', bottom: 0, width: '100%', height: '5em', backgroundColor: '#000', padding: '5px 0 5px 0', color: '#fff' }}>
            <div>
                <Grid container>
                    <Grid item xs={12} style={{ fontSize: !phoneMode ? '12px' : '10px' }}>
                        <p style={{ margin: !isMobile ? '12px 5em' : '0px 0.5em', textAlign: isMobile ? 'center' : null }}>
                            © {new Date().getFullYear()} Mercury Marine. All Rights Reserved.
                            {phoneMode ? <br /> : null}
                            <a href="https://www.brunswick.com/terms-of-use/" target="_blank"
                                style={{ color: '#fff', paddingLeft: '10px', textDecoration: 'underline', borderBottom: 'none' }}>
                                Terms &amp; Conditions
                            </a>
                            <a href="https://www.brunswick.com/privacy-policy/" target="_blank"
                                style={{ color: '#fff', paddingLeft: '10px', textDecoration: 'underline', borderBottom: 'none' }}>
                                Privacy Policy
                            </a>
                            <a href="https://rs.brunswick.com/"
                                style={{ color: '#fff', paddingLeft: '10px', textDecoration: 'underline', borderBottom: 'none' }}>
                                Remote
                            </a>
                        </p>
                        <p style={{ margin: !isMobile ? '12px 5em' : '0px 0.5em', textAlign: isMobile ? 'center' : null }}>
                            Reproduction in whole or in part without permission is prohibited. Mercury Marine is a division of Brunswick Corporation.
                        </p>
                    </Grid>
                </Grid>
            </div>
        </footer>
    );
}